import { Iconos } from '../componentes/iconos';
import {
  Cargando,
  Celda,
  Chip,
  Encabezado,
  ErrorCaja,
  Fila,
  Panel,
  Tabla,
  Vacio,
} from '../componentes/ui';
import { useRecurso } from '../lib/consultas';

interface TipoVisita {
  id: string;
  nombre: string;
  color: string;
  requiereFotoRostro: boolean;
  requiereFotoIdentificacion: boolean;
  requiereAutorizacion: boolean;
  activo: boolean;
}

/** Un check verde o un guion: se lee de un vistazo mejor que "Sí"/"No". */
function Marca({ v }: { v: boolean }) {
  return v ? (
    <span className="text-success">
      <Iconos.correcto tam={20} />
    </span>
  ) : (
    <span className="text-outline-variant" aria-label="no">
      —
    </span>
  );
}

export function TiposVisitaPagina() {
  const { datos, cargando, error } = useRecurso<TipoVisita[]>('/topologia/tipos-visita');
  const lista = datos ?? [];

  return (
    <>
      <Encabezado
        titulo="Tipos de visita"
        descripcion="Qué fotos exige cada tipo y con qué color lo distingue el guardia en pantalla"
      />

      <Panel>
        {error && <ErrorCaja>{error}</ErrorCaja>}
        {cargando && <Cargando />}
        {!cargando && !error && lista.length === 0 && (
          <Vacio>No hay tipos de visita configurados.</Vacio>
        )}

        {!cargando && !error && lista.length > 0 && (
          <Tabla
            cabeceras={[
              'Tipo',
              'Foto de rostro',
              'Foto de identificación',
              'Requiere autorización',
              'Estado',
            ]}
          >
            {lista.map((t) => (
              <Fila key={t.id}>
                <Celda>
                  <Chip color={t.color}>{t.nombre}</Chip>
                </Celda>
                <Celda>
                  <Marca v={t.requiereFotoRostro} />
                </Celda>
                <Celda>
                  <Marca v={t.requiereFotoIdentificacion} />
                </Celda>
                <Celda>
                  <Marca v={t.requiereAutorizacion} />
                </Celda>
                <Celda>
                  <Chip tono={t.activo ? 'ok' : 'neutro'}>{t.activo ? 'Activo' : 'Inactivo'}</Chip>
                </Celda>
              </Fila>
            ))}
          </Tabla>
        )}
      </Panel>
    </>
  );
}
